import { render, staticRenderFns } from "./BaseMitCalendar.vue?vue&type=template&id=5edf0dab&scoped=true"
import script from "./BaseMitCalendar.vue?vue&type=script&lang=js"
export * from "./BaseMitCalendar.vue?vue&type=script&lang=js"
import style0 from "./BaseMitCalendar.vue?vue&type=style&index=0&id=5edf0dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf0dab",
  null
  
)

export default component.exports